import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SpectraSecurityLanding from "./components/SpectraSecurityLanding";
import LegalPage from "./components/LegalPage";
import Careers from "./components/Careers";
import Blog from "./components/Blog";
import About from "./components/About";
import { CookieConsent } from "./components/CookieConsent";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SpectraSecurityLanding />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about-us" element={<About />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
